
import no_poverty from "../assets/sdg_logos/no_poverty.png"
import zero_hunger from "../assets/sdg_logos/zero_hunger.png"
import good_health from "../assets/sdg_logos/good_health.png"
import education from "../assets/sdg_logos/education.png"

import gender_equality from "../assets/sdg_logos/gender_equality.png"
import clean_water from "../assets/sdg_logos/clean_water.png"
import clean_energy from "../assets/sdg_logos/clean_energy.png"
import economic_growth from "../assets/sdg_logos/economic_growth.png"

import infrastructure from "../assets/sdg_logos/infrastructure.png"
import no_inequality from "../assets/sdg_logos/equal_countries.png"
import sustainability from "../assets/sdg_logos/sustainability.png"
import responsible_consumption from "../assets/sdg_logos/responsible_consumption.png"

import climate_action from "../assets/sdg_logos/climate_action.png"
import life_underwater from "../assets/sdg_logos/life_underwater.png"
import life_on_land from "../assets/sdg_logos/life_onland.png"
import peace_and_justice from "../assets/sdg_logos/peace_and_justice.png"
import partnership from "../assets/sdg_logos/partnership.png"

export default [
    no_poverty, 
    zero_hunger, 
    good_health, 
    education,

    gender_equality,
    clean_water,
    clean_energy,
    economic_growth,

    infrastructure,
    no_inequality,
    sustainability,
    responsible_consumption,

    climate_action,
    life_underwater,
    life_on_land,
    peace_and_justice,
    partnership
]